import { computed, reactive, readonly, toRefs } from "vue";
import axios from "axios";

const state = reactive({
  banks: [],
  selectedBankId: null
});

export async function banksInit(countryId = null) {
  try {
    const {
      data: { banks, success }
    } = await axios.get(
      `get/api/bankLink/banks${countryId ? `?country_id=${countryId}` : ""}`
    );
    const collectBanks = [];

    let isFirst = true;
    for await (const [bankId, bankData] of Object.entries(banks)) {
      collectBanks.push({
        id: bankId,
        name: bankData.name,
        type: bankData.type || null,
        image: window.room_rent.bank.logoByKey[bankData.sys_tag] || ""
      });
      if (isFirst && bankData.type === "bank") {
        state.selectedBankId = bankId;
        isFirst = false;
      }
    }

    if (!state.selectedBankId && state.banks.length) {
      state.selectedBankId = state.banks[0].id;
    }

    state.banks = collectBanks;

    return {
      success
    };
  } catch (error) {
    console.error(error);
  }

  return {
    success: false
  };
}

export const banks = readonly(toRefs(state).banks);
export const selectedBankId = readonly(toRefs(state).selectedBankId);
export function setSelectedBankId(id) {
  state.selectedBankId = id;
}

export const selectedBankType = computed(() => {
  let type = null;

  state.banks.forEach(bank => {
    if (bank.id === state.selectedBankId) {
      type = bank.type;
    }
  });

  return type;
});
